import { AsyncState, loadedAsyncState, loadingAsyncState } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { BlocksState } from '../cmsPage/blocks/blocksState'
import { crisisBannerApi } from './crisisBannerApi'

export type CrisisBannerState = AsyncState<BlocksState>

export const initialCrisisBannerState = loadingAsyncState(crisisBannerApi)

export const crisisbannerStateUpdaters = {
  blocksStateUpdater:
    (updater: Updater<BlocksState>) =>
    (state: AsyncState<BlocksState>): AsyncState<BlocksState> =>
      state.kind === 'loaded' ? loadedAsyncState(updater(state.value)) : state,
}
